import * as React from 'react';
import { registerIcons } from '@fluentui/style-utilities';
import { createSvgIcon } from 'owa-fluent-icons-svg/lib/createSvgIcon';

export default 'BackColorPickerIcon';

const BackColorPickerIcon = createSvgIcon({
    Svg: props => (
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.082 2C11.2635 2.00005 11.441 2.05392 11.5919 2.15479C11.7428 2.25567 11.8604 2.39902 11.9299 2.56673C11.9993 2.73444 12.0175 2.91898 11.9821 3.09703C11.9467 3.27507 11.8593 3.43862 11.731 3.567L6.173 9.125C6.0602 9.23747 5.9204 9.31907 5.767 9.362L4.213 9.787L4.638 8.233C4.68075 8.07982 4.76239 7.9403 4.875 7.828L10.433 2.269C10.518 2.18344 10.6191 2.1156 10.7305 2.06942C10.8419 2.02325 10.9614 1.99965 11.082 2ZM11.082 1C10.8301 0.999789 10.5807 1.04933 10.348 1.14577C10.1153 1.24221 9.90389 1.38366 9.726 1.562L4.168 7.12C3.93251 7.35538 3.76227 7.64795 3.674 7.969L3.018 10.369C3.00596 10.4116 2.9999 10.4557 3 10.5C3 10.6326 3.05268 10.7598 3.14645 10.8536C3.24022 10.9473 3.36739 11 3.5 11C3.54463 11.0002 3.58906 10.9941 3.632 10.982L6.032 10.326C6.35305 10.2377 6.64562 10.0675 6.881 9.832L12.439 4.274C12.7072 4.00571 12.8898 3.6639 12.9638 3.29181C13.0377 2.91972 12.9996 2.53407 12.8544 2.18361C12.7091 1.83316 12.4632 1.53366 12.1477 1.32297C11.8322 1.11229 11.4614 0.999894 11.082 1Z" />
            <path d="M2.73 12.07a1.75 1.75 0 001.23.12l2.4-.66a3.16 3.16 0 001.4-.81l.72-.72h5.02c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 011 13.5v-2c0-.57.32-1.06.78-1.32a1.75 1.75 0 00.95 1.89z" />
        </svg>
    ),
    displayName: 'BackColorPickerIcon',
});

registerIcons({
    icons: {
        BackColorPickerIcon: <BackColorPickerIcon />,
    },
});
